/* Ordinia · ficha de producto digital: galería, preguntas, aparición al hacer scroll y CTA fija en móvil.
   Sin JS todo se ve (galería con scroll, respuestas abiertas, bloques visibles). */
(() => {
  const roots = document.querySelectorAll('[data-od-pp]');
  roots.forEach((root) => {
    if (root.dataset.odReady) return;
    root.dataset.odReady = '1';
    root.classList.add('od-js', 'od-pp-js');

    /* Galería */
    const gal = root.querySelector('[data-od-gallery]');
    const track = gal && gal.querySelector('[data-od-track]');
    if (track) {
      const slides = Array.from(track.querySelectorAll('[data-od-slide]'));
      const thumbs = Array.from(gal.querySelectorAll('[data-od-go]'));
      const num = gal.querySelector('[data-od-gn]');
      const file = gal.querySelector('[data-od-gfile]');
      let cur = 0;
      const pad = (n) => String(n).padStart(2, '0');
      const mark = (i) => {
        if (i === cur || !slides[i]) return;
        cur = i;
        thumbs.forEach((t, k) => (k === i ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
        if (num) {
          num.textContent = pad(i + 1);
          num.classList.remove('is-roll');
          void num.offsetWidth;
          num.classList.add('is-roll');
        }
        if (file && slides[i].dataset.odFile) file.textContent = slides[i].dataset.odFile;
      };
      const go = (i) => {
        const n = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[n].offsetLeft, behavior: 'smooth' });
        mark(n);
      };
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const w = track.clientWidth || 1;
          mark(Math.round(track.scrollLeft / w));
        });
      }, { passive: true });
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
        else if (e.key === 'Home') { e.preventDefault(); go(0); }
        else if (e.key === 'End') { e.preventDefault(); go(slides.length - 1); }
      });
      thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.odGo) || 0)));
    }

    /* Preguntas */
    root.querySelectorAll('.od-faq__q').forEach((q) => {
      q.addEventListener('click', () => {
        q.setAttribute('aria-expanded', q.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });

    /* Aparición de bloques */
    const rv = root.querySelectorAll('[data-od-rv]');
    if ('IntersectionObserver' in window) {
      let alive = false;
      /* Seguro: si el observador no responde (pestaña en segundo plano rara, webview), se muestra todo */
      setTimeout(() => { if (!alive) rv.forEach((el) => el.classList.add('is-in')); }, 3000);
      const io = new IntersectionObserver((entries) => {
        alive = true;
        entries.forEach((en) => {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      rv.forEach((el) => io.observe(el));
    } else {
      rv.forEach((el) => el.classList.add('is-in'));
    }

    /* Evitar doble envío */
    const form = root.querySelector('[data-od-form]');
    const buy = root.querySelector('[data-od-buy]');
    if (form && buy) form.addEventListener('submit', () => buy.classList.add('is-busy'));

    /* CTA fija en móvil: visible cuando el botón principal ha quedado por encima de la pantalla */
    const sticky = root.querySelector('[data-od-sticky]');
    if (sticky && buy && 'IntersectionObserver' in window) {
      const show = (on) => {
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      };
      new IntersectionObserver(([en]) => {
        show(!en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(buy);
    }
  });
})();
